import React from "react";
import T from "./Translate/T";

const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2"><T>About Me</T></span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          <T>Know Me More</T>
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              <T>Hi, I'm</T>{" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                Carlos A. Ramirez
              </span>
            </h2>
            <p className="text-5">
              <T>Highly analytical Software Engineer/System Architect with 10+ years of Canadian experience demonstrating expertise in managing Full Stack Developer projects utilizing PHP and Java, MVC frameworks: Laravel 10 & 12, TypeScript, CodeIgniter, Zend, HTML5, CSS, Node.js, pre-processed CSS/Sass, Next.js and React.js.</T>
              {" "}
              <br/>
              <T>Experienced in deploying secure RESTful services implementing OAuth 2.1 authentication and authorization protocols.</T>
              {" "}
              <br/>
              <T>With training in Big Data Analytics, proficient in leveraging AI-powered development tools including Claude and Cursor to enhance productivity and code quality.</T>
              {" "}
              <br/>
              <T>Known for building professional websites with well-designed database architecture and delivering web solutions using Agile and SDLC methodologies.</T>
              <br/>
              <T>Bilingual (English/Spanish) with deep familiarity with both North American and Latin American business contexts, uniquely positioned for remote roles bringing North America with LATAM markets.</T>
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  10+
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                <T>Years of</T> <span className="fw-700"><T>Experience</T></span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0"><T>Name:</T></p>
            <p className="text-4 text-dark fw-600 mb-0">Carlos A. Ramirez</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0"><T>Email:</T></p>
            <p className="text-4 fw-600 mb-0">
              <a className="link-dark" href="mailto:carlos.a.ramirez.e@gmail.com">
                carlos.a.ramirez.e@gmail.com
              </a>
            </p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutUs;